module.exports = __webpack_public_path__ + "img/cyberpunkbanner.86dc8ed7.png";